import server from "../server.js";

/************ 统一用户 **********/

//登录
const login = (data) => {
    console.log("login:"+JSON.stringify(data));
    return server.post({
        url: server.baseUrl + '/user/login',
        data,
        noToken: true,
    });
};

const getMSMCode = (data) => {
    return server.post({
        url: server.baseUrl + "/user/sendSms",
        data,
        noToken: true,
    });
};

const getAccountInfo = (data) => {
    return server.get({
        url: server.baseUrl + "/user/info",
        data,
        noToken: true
    })
};

const resetPsd = (data) => {
    return server.post({
        url: server.baseUrl + "/user/forget",
        data,
        noToken: true
    });
};


const loginFirst = (data) => {
    return server.post({
        url: server.baseUrl+"/user/login/first",
        data,
        noToken: true
    })
};

// 新增用户
const addUser = (data) => {
    return server.post({
        url: server.baseUrl+"/user/add",
        data,
    })
};

// 更新用户
const updateUser = (data) => {
    return server.post({
        url: server.baseUrl+"/user/update",
        data,
    })
};

// 更新用户
const deleteUser = (data) => {
    return server.post({
        url: server.baseUrl+"/user/delete",
        data,
    })
};

// 获取所有用户
const getAllUsers = (data) => {
    return server.get({
        url: server.baseUrl+"/user/list",
        data,
    })
};


export default {
    login,
    getMSMCode,
    getAccountInfo,
    resetPsd,
    loginFirst,
    addUser,
    updateUser,
    deleteUser,
    getAllUsers,
    
};